import { createApiStore } from "./genericStore";
import api from "../service/api";
import { VisitRoute, VisitTemplate } from "../types/visit";

const useVisitRouteBase = createApiStore<VisitRoute & { id: number }>("/visit");
const useVisitTemplateBase = createApiStore<VisitTemplate & { id: number }>("/visit-template");

export const useVisitManagementStore = () => {
  const routeStore = useVisitRouteBase();
  const templateStore = useVisitTemplateBase();

  return {
    routes: routeStore,
    templates: templateStore,

    monitorPlasiyer: async (employeeId: number, date?: string, startDate?: string, endDate?: string) => {
      try {
        // genericStore'un sunduğu state değişkenlerini doğrudan kontrol ediyoruz
        // Eğer setterlar yoksa Zustand'ın içsel setState'ini veya store aksiyonlarını kullanmalıyız
        // Genelde genericStore'da 'loading' veya 'items' doğrudan erişilebilirdir
        
        const res = await api.get(`/visit/admin/monitor/${employeeId}`, {
          params: { date, startDate, endDate }
        });
        
        // Veriyi manuel güncelleme: genericStore yapına göre burası değişebilir.
        // Eğer genericStore bir Zustand yapısı ise:
        useVisitRouteBase.setState({ 
          data: res.data, 
          total: res.data.length,
          loading: false 
        });

        return res.data;
      } catch (err) {
        console.error("Monitor hatası:", err);
        useVisitRouteBase.setState({ loading: false });
        throw err;
      }
    },

    postponeVisit: async (data: { 
      visitRouteId?: number, 
      accountId: number, 
      addressId?: number, 
      postponeToDate: Date, 
      reason: string 
    }) => {
      return (await api.post(`/visit/postpone`, data)).data;
    },

    duplicateWeeklyPlan: async (fromEmployeeId: number, toEmployeeId: number) => {
      return (await api.post(`/visit-template/duplicate`, { 
        fromEmployeeId, 
        toEmployeeId 
      })).data;
    },

    fetchTemplatesByEmployee: async (employeeId: number) => {
      return await templateStore.fetchDataDynamic({
        pageIndex: 1,
        pageSize: 1000,
        filter: {
          logic: "and",
          filters: [{ field: "employeeId", operator: "eq", value: employeeId }]
        }
      });
    }
  };
};